import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  root: {},
  categoriesContainer: {
    marginTop: 10
  },
  category: {
    margin: 3,
    backgroundColor: '#F0F0F0',
    borderRadius: 8,
    padding: '5px 10px'
  },
  enabledCategory: {
    backgroundColor: '#E9FDF3'
  }
}))

const CopilotUtilizationCategories = ({ practiceGuidelinesConfiguration = [] }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const isAllEnabled = practiceGuidelinesConfiguration.every(category => category.isEnabled)

  return (
    <Grid container direction="column" className={classes.root} wrap="nowrap">
      <DazzedHeading14 regular>
        {isAllEnabled
          ? t('pages.copilotControl.mainPage.copilotUtilization.allEnabled')
          : t('pages.copilotControl.mainPage.copilotUtilization.enableMore')}
      </DazzedHeading14>
      <Grid container className={classes.categoriesContainer}>
        {practiceGuidelinesConfiguration.map((category, index) => (
          <div className={[classes.category, category.isEnabled ? classes.enabledCategory : ''].join(' ')} key={index}>
            {t(`pages.accountSettings.practiceGuidelines.categories.${category.categoryKey}.copilotUtilizationLabel`)}
          </div>
        ))}
      </Grid>
    </Grid>
  )
}

export default CopilotUtilizationCategories
